module.exports = __webpack_public_path__ + "img/infos.d4815b95.png";